import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessagesTemplatesService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  save(payload: { text: string }) {
    const url = environment.baseURL + '/mt/';
    return this.http.post<any>(url, payload)
      .pipe(map(v => v.data));
  }

  update(id: string, payload: { text: string }) {
    const url = environment.baseURL + `/mt/${id}`;
    return this.http.put<any>(url, payload)
      .pipe(map(v => v.data));
  }

  get() {
    const url = environment.baseURL + '/mt/';
    return this.http.get<any>(url)
      .pipe(map(v => v.data));
  }

  delete(id: string) {
    const url = environment.baseURL + `/mt/${id}`;
    return this.http.delete<any>(url)
      .pipe(map(v => v.data));
  }

  reorder(payload: any) {
    const url = environment.baseURL + '/mt/reorder';
    return this.http.post<any>(url, payload)
      .pipe(map(v => v.data));
  }
}
